module.exports = __webpack_public_path__ + "img/shoushi02.1b5e9bea.png";